import React from "react";
import { showToast } from "../Toast/Toast";
const sizeClasses = {
  xs: "px-2 py-0",
  sm: "px-3 py-1.5",
  md: "px-3 py-2",
  lg: "px-4 py-2.5",
  xl: "px-5 py-3",
};

const fontSizeClasses = {
  xs: "text-[12px]",
  sm: "text-[12px]",
  md: "text-[14px]",
  lg: "text-[16px]",
  xl: "text-[18px]",
};

const TextArea = ({
  value,
  onChange,
  placeholder = "Enter text...",
  size = "md",
  rounded = "rounded",
  rows = 4,
  disabled,
  shadow = false,
  maxLength = 300,
}) => {
  const handleChange = (e) => {
    const newValue = e.target.value;

    if (newValue.length > maxLength) {
      showToast(`Character limit of ${maxLength} reached!`, "error");
      return;
    }

    if (!disabled) {
      onChange(newValue);
    }
  };

  return (
    <textarea
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      rows={rows}
      disabled={disabled}
      className={`w-full border focus:outline-none resize-none 
        ${shadow ? "border-gray-50 inputShadow" : "border-gray-300"}
        ${sizeClasses[size]} ${fontSizeClasses[size]} ${rounded}
      ${
        disabled
          ? "border-neutrals-200 bg-neutrals-200 cursor-not-allowed text-black"
          : "bg-white focus:border-primary"
      }`}
    />
  );
};

export default TextArea;
